import * as Sentry from '@sentry/nuxt'
const runtimeConfig = useRuntimeConfig()
Sentry.init({
  dsn: runtimeConfig.public.SENTRY_DSN || '',
  environment: runtimeConfig.public.SENTRY_ENVIRONMENT || 'local',
  release: runtimeConfig.public.SENTRY_RELEASE || 'local',
  tracesSampleRate: parseFloat(
    runtimeConfig.public.SENTRY_TRACE_SAMPLE_RATE || '0.1'
  ),
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.captureConsoleIntegration({ levels: ['warn', 'error'] })
  ],
  attachStacktrace: true,
  tracingOptions: {
    hooks: ['mount', 'update', 'create'],
    trackComponents: true
  }
})
